import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'app-package-installed-app-editor',
    templateUrl: './package-installed-app-editor.component.html',
    styleUrls: ['./package-installed-app-editor.component.scss'],
    standalone: false
})
export class PackageInstalledAppEditorComponent implements OnChanges, OnInit {

  @Input() index;
  @Input() compositionApp: Models.CompositionApp;
  @Input() installedApp: Models.PackageInstalledApp;
  @Input() dynamicEntranceApp: Models.DynamicContentEntrance;
  @Input() codeSnippetApp: Models.CodeSnippet;
  @Input() availableLanguages: any[];
  @Input() package: Models.Package;
  @Output() installedAppRemoved: EventEmitter<string> = new EventEmitter();
  @Output() installedAppSave: EventEmitter<string> = new EventEmitter();
  @Output() resetHighscore: EventEmitter<boolean> = new EventEmitter();
  public hasHighScoreReset;
  public superadmin = false;
  public codeEditorOptions = { maxLines: 30, minLines: 20, fontSize: '16px', autoScrollEditorIntoView: true };

  constructor(private ms: MessengerService) {
  }

  ngOnInit() {
    const privileges = this.ms.$superadminPrivileges.getValue();

    if (!!privileges) {
      for (const privilege of privileges) {
        if (privilege.privilegeName === 'superadmin' && privilege.value === 'packages') {
          this.superadmin = true;
        }
      }
    }
  }

  ngOnChanges() {
    if (this.compositionApp) {
      this.createTranslations(this.compositionApp.name);
      if (!this.installedApp.iconOverride) {
        this.installedApp.iconOverride = this.compositionApp.icon;
      }
    }
    if (this.dynamicEntranceApp) {
      this.hasHighScoreReset = this.dynamicEntranceApp.config && this.dynamicEntranceApp.config.overwriteContentType === 'memory' || this.installedApp.detail.appType === 'memory';
      this.createTranslations(this.dynamicEntranceApp.title);
    }
    if (this.codeSnippetApp) {
      this.createTranslations(this.codeSnippetApp.title);
    }
  }

  public removeInstalledApp(): void {
    this.installedAppRemoved.emit(this.index);
  }

  public saveInstalledApps(): void {
    this.installedAppSave.emit(this.index);
  }

  cancelTiming() {
    this.installedApp.from = null;
    this.installedApp.to = null;
    this.installedAppSave.emit(this.index);
  }

  private createTranslations(title) {
    if (this.compareLanguageArrays(this.availableLanguages, this.installedApp.translations)) {
      return;
    }
    for (let i = 0; i < this.availableLanguages.length; i++) {
      let hasLanguage = false;
      if (!this.installedApp.translations) {
        this.installedApp.translations = [];
      }
      for (let j = 0; j < this.installedApp.translations.length; j++) {
        if (this.availableLanguages[i] === this.installedApp.translations[j].language) {
          hasLanguage = true;
        }
      }
      if (!hasLanguage) {
        const newTranslation = new Models.PackageInstalledAppTranslation();
        newTranslation.populateFromJSON({
          language: this.availableLanguages[i],
          hidden: false,
          appTitle: title
        });
        this.installedApp.translations.splice(i, 0, newTranslation);
      }
    }
  }

  private compareLanguageArrays(available: string[], appTranslations: any[]) {
    let languagesMatch = available.length === appTranslations.length;
    for (const translation of appTranslations) {
      if (available.indexOf(translation.language) < 0) {
        languagesMatch = false;
      }
    }
    return languagesMatch;
  }

}
